import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {ReportComponent} from "./reports/report.component";
import {CustomAuthGuard} from "./guards/auth.guard";

const routes: Routes = [
  {
    path: ':name',
    component: ReportComponent,
    canActivate: [CustomAuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
